import { Row, } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const DrawerBodyElementWrapper = styled(Row)`
  > .ant-col:first-child {
    &-text{
      color: ${"#8c8c8c"};
      font-weight: 500;
    }
  }

  > .ant-col:last-child {
    line-height: 24px;
    color: ${"#434343"};
  }
`;

export const TitleRow = styled(Row)`
  .anticon > svg {
    height: 28px;
    width: 28px;
    color: ${"#f0f0f0"};

    > path:last-child {
      color: ${"#434343"};
    }
  }
`;

export const GlobalDrawerStyles = createGlobalStyle`
.ant-drawer.right-drawer {
  > .ant-drawer-content-wrapper > .ant-drawer-content {
    border-radius: 24px 0 0 24px;

    .ant-drawer-header {
      padding: 24px 24px 18px;
      border: none;
    }
  }
}
`;
